let waitUntil=function(){var ref=_asyncToGenerator(

function*(predicate){let delayInMilliseconds=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0;
while(!predicate()){
yield delay(delayInMilliseconds);
}
});return function waitUntil(predicate){let delayInMilliseconds=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0;return ref.apply(this,arguments)}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}const delay=require('pulsar-utils/dist-es6/async/delay');

module.exports=waitUntil;
//# sourceMappingURL=waitUntil.js.map
